import styled from 'styled-components';

export const StyledNav = styled.nav`
  width: 100%;
  height: 4rem;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
`;
